export default __webpack_public_path__ + "static/media/dark-view.1ce50e21.svg";